import { getLanguage } from "@docspace/shared/utils";
import { translations } from "./autoGeneratedTranslations";

export function loadLanguagePath(homepage, fixedNS = null) {
  return (lng, ns) => {
    const language = getLanguage(lng instanceof Array ? lng[0] : lng);

    const lngCollection = translations?.get(language);

    const data = lngCollection?.get(`${fixedNS || ns}`);

    if (!data) return `/locales/${language}/${fixedNS || ns}.json`;

    let path = data?.split("/");
    const length = path?.length;

    const isCommonPath = path[length - 1].indexOf("Common") > -1;

    path = `/${path[length - 3]}/${path[length - 2]}/${path[length - 1]}`;

    if (ns.length > 0 && ns[0] === "Common" && isCommonPath) {
      return `/static${path}`;
    }

    return path;
  };
}
